<template>
    <div>
      <b-container fluid class="mt-0 pb-5 mb-5">
            <b-row>
                <b-col xl="12">
                    <div class="p-0 pt-0 pb-5">
                        <h3 class="pl-3 pt-3 pb-2">{{ $t('Transaction History') }}</h3>
        
                        <div class="block-item rounded mb-4 pl-4 pr-4 pt-3 pb-3">
                            <span class="fz-24 fw-600">{{ $t('Choose Card') }}</span>
                            <hr class="m-0 mb-2"/>
                            <b-row>
                                <b-col sm="12" md="6" lg="3" class="p-0" v-for="i in 4" :key="i">
                                    <div v-if="card_list[i-1]" :class="(i-1==current)?'card-account active':'card-account'" @click="setCurrent(i-1)">
                                        <div class="account-name" :class="card_list[i-1].addClass">{{card_list[i-1].account_name}}</div>
                                        <div class="number-1" :class="card_list[i-1].addClass">{{card_list[i-1].card_number}}</div>
                                        <div class="text-label balance-label" :class="card_list[i-1].addClass">Balance</div>
                                        <div class="number-3" :class="card_list[i-1].addClass"><span v-if="card_list[i-1].currency">{{card_list[i-1].currency}}</span> <span v-if="card_list[i-1].balance">{{card_list[i-1].balance}}</span><span v-else>...</span></div>
                                        <div class="text-label expiry-label" :class="card_list[i-1].addClass">Expiry Date</div>
                                        <div class="number-4" :class="card_list[i-1].addClass">{{card_list[i-1].exp_date}}</div>
                                        <img :src="card_list[i-1].provider.image" class="w-100"/>
                                    </div>
                                    <div v-else class="card-account p-1">
                                        <a href="card-management">
                                            <img :src="`${publicPath}/img/rcp/card/empty.png`" class="w-100"/>
                                            <div class="add-card-button">{{ $t('Add Card') }}</div>
                                        </a>
                                    </div>
                                </b-col>
                            </b-row>
                        </div>
                        <div class="block-item rounded mb-4 p-3">
                            <b-row>
                                <b-col sm="12" md="6" v-if="card_list[current]">
                                    <div class="d-flex align-items-center">
                                        <img :src="`${publicPath}/img/rcp/icon/card.png`"/>
                                        <div class="d-flex flex-column ml-1">
                                            <span class="fz-24 fw-800 text-orange">{{card_list[current].card_number}}</span>
                                            <span class="small text-blue card-caption">{{card_list[current].currency}}|{{card_list[current].exp_date}}</span>
                                        </div>
                                    </div>
                                </b-col>
                                <b-col sm="12" md="6" v-if="card_list[current]">
                                    <div class="d-flex flex-column ml-1 text-right">
                                        <span class="small text-blue">{{ $t('Available to spend') }}</span>
                                        <span class="fz-24 fw-800 text-orange"><span v-if="card_list[current].balance">{{card_list[current].balance}}</span><span v-else>...</span> <span v-if="card_list[current].currency">{{card_list[current].currency}}</span></span>
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col lg="12">
                                    <TransactionHistoryTable :current_card="current" ref="transactionHistory"></TransactionHistoryTable>
                                </b-col>
                            </b-row>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>    
</template>
  <script>
    import Vue from 'vue'
    import TransactionHistoryTable from '@/components/TransactionHistoryTable.vue';
    import Common from '@/services/Common';
    import Global from '@/services/Global';
    const CARD_TYPE = ['physical','virtual'];
  
    export default {
        name: 'transaction',
        data() {
            return {
                publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
                current:0,
                card_list:[],
                card_data:[],
                current_index:0
            }
        },
        components: {
            TransactionHistoryTable
        },
        methods: {
            getProfile(){
                const isFirstTime = localStorage.getItem("isFirstTime");
                if(isFirstTime == "true"){
                    this.$router.push({ path: '/change-password' });
                }
                else{
                    Common.profile().then(response => {
                    if(response.status == 200 && response.data.success){
                        const profile = response.data.data;
                        if(profile.fullname==null){
                            router.push({ path: '/' })
                        }
                    }
                    }).catch(err => {
                        this.checkError(err);
                    });
                }
            },
            setCurrent(index){
                this.current = index;
                this.$refs['transactionHistory'].onChange(this.current);
            },
            getCardInfo(item){
                const card_number = item.card_number.match(/.{1,4}/g);
                Common.card_list_utgl({"cardAccountId":item.card_account_id}).then(response => {
                    if(response.status == 200){      
                        const data = response.data.data.cardAccounts[0]; 

                        if(item.currency=="USD"){
                            item.addClass = "";
                            item.provider.image = this.publicPath+"/img/rcp/card/background-7.png";
                        }
                        else if(item.currency=="HKD"){
                            item.addClass = "text-grey3";
                            item.provider.image = this.publicPath+"/img/rcp/card/Card_HKD.png";
                        }
                        
                        this.card_list.push({
                            "addClass":item.addClass,
                            "provider":item.provider,
                            "card_account_id":item.card_account_id,
                            "card_id":item.card_id,
                            "account_name":item.embossed_name,
                            "card_number":card_number.join(" "),
                            "currency":item.currency,
                            "balance":Global.addCommas(data.available),
                            "exp_date":item.expiry_month+"/"+item.expiry_year
                        });
                        this.current_index++;
                        if(this.current_index<this.card_data.length){
                            this.getCardInfo(this.card_data[this.current_index]);
                        }
                    }
                }).catch(err => {
                    this.checkError(err);
                });
            },
            checkError(err){
                try{
                    const response = err.response;
                    if(response.status == 401 && response.data.name == "Unauthorized"){
                        localStorage.removeItem("token");
                        localStorage.removeItem("member");
                        localStorage.removeItem("isFirstTime");
                        this.$router.push({ 
                        path: '/login', 
                        });
                    }
                    else{
                        var msg = (response.data)?response.data.message:err.message;
                            this.$notify({
                            type: 'warn',
                            text: msg
                        })
                    }
                }
                catch(e){
                    console.log(err);
                }
            }
        },
        mounted(){
            this.getProfile();
            Common.card_active().then(response => {
                if(response.status == 200){
                    this.card_data = response.data.data;
                    let item = this.card_data[this.current_index];
                    this.current_index = 0;
                    
                    if(process.env.VUE_APP_ENVIRONMENT != "production" || item.provider.type != CARD_TYPE[0]){
                        do{
                            let item = this.card_data[this.current_index];
                            const card_number = item.card_number.match(/.{1,4}/g);
                            if(item.currency=="USD"){
                                item.addClass = "";
                                item.provider.image = this.publicPath+"/img/rcp/card/background-7.png";
                            }
                            else if(item.currency=="HKD"){
                                item.addClass = "text-grey3";
                                item.provider.image = this.publicPath+"/img/rcp/card/Card_HKD.png";
                            }

                            this.card_list.push({
                                "addClass":item.addClass,
                                "provider":item.provider,
                                "card_account_id":item.card_account_id,
                                "card_id":item.card_id,
                                "account_name":item.embossed_name,
                                "card_number":card_number.join(" "),
                                "currency":item.currency,
                                "exp_date":item.expiry_month+"/"+item.expiry_year
                            });
                            this.current_index++;
                        }while(this.current_index<this.card_data.length);

                    }
                    else{
                        this.getCardInfo(item);
                    }
                        
                }
            }).catch(err => {
                this.checkError(err);
            });
        }
    };
  </script>
  